import SocialPostPreview from "../SocialPublishing/SocialPostPreviews";
import { creatorCover, demoCreator, demoCreatorName } from "./homeCreatorContent";
import styles from "./HomeCreatorLanding.module.scss";

const connection = { provider: "bluesky", displayName: demoCreatorName, handle: demoCreator.nickname };

export default function CreatorSocialPreview() {
  return <div className={styles.socialPreview} aria-label="Social post preview">
    <div className={styles.previewLabel}><strong>Social posts</strong></div>
    <SocialPostPreview connection={connection} imageUrl={creatorCover.src}
      imageProps={{ alt: creatorCover.alt, width: creatorCover.width, height: creatorCover.height,
        srcSet: creatorCover.srcSet, sizes: "(max-width: 900px) calc(100vw - 174px), 464px" }}
      text="New episode lands on Friday. We talked about creative work, second drafts, and knowing when to stop tweaking. Here's the cover I've been working on." />
  </div>;
}
